import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["href"]

import { getCurrentInstance } from "vue";
import useDepartment from "@/composables/use-department";
import ListItem from "./ListItem.vue";
import { contextPath } from "@/services/ocm-object";
import useSearch from "@/composables/use-search";


export default /*#__PURE__*/_defineComponent({
  __name: 'FindingsShopItem',
  props: {
    findings: null
  },
  setup(__props: any) {



const uid = getCurrentInstance()?.uid ?? 1;
const { resetSearch } = useSearch();
const { departmentCapitalized, department } = useDepartment();

const routeToSearchResults = (event: Event) => {
	window.ocmOrchestrator && window.ocmOrchestrator.spaNavigateUrl(event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.findings, (finding, i) => {
    return (_openBlock(), _createElementBlock("a", {
      key: `finding-${_unref(uid)}-${i}`,
      href: `${_unref(contextPath)}/suche/?s=${encodeURIComponent(
			finding
		)}&department=${_unref(department)}#/Kategorie/${_unref(departmentCapitalized)}`,
      class: "-mx-4 block px-4 font-normal hover:bg-gray-20",
      onClick: _cache[0] || (_cache[0] = ($event: any) => {
			routeToSearchResults($event);
			_unref(resetSearch)();
		})
    }, [
      _createVNode(ListItem, { text: finding }, null, 8, ["text"])
    ], 8, _hoisted_1))
  }), 128))
}
}

})